/**
* @description
* # name controller --> enabledEducatorsListController
* # As Controller --> enabledEducatorsList
*/

export default class enabledEducatorsListController {
	constructor($scope,enabledEducatorsServices,ngNotify,UserInfoConstant,$state,$filter,levelsServices, educatorsServices) {
		this.$scope = $scope;
		this.ngNotify = ngNotify;
		this.$state = $state;
		this.services = enabledEducatorsServices.services
		this.servicesPeriod = enabledEducatorsServices.servicesPeriod
		this.educatorsServices = educatorsServices.services
		this.levelsServices = levelsServices.services
		this.$scope.buttonActions = false
		this.$scope.grid = false;
		this.$scope.edit = true;
		this.$scope.titleList = true;
		this.$translate = $filter('translate')
		this.conceptId = 0
		this.$scope.periodSelect = null
		this.$scope.levelSelect = null
		this.educatorName = null
		this.detailsEnabled ={
			enableFiltering: true
		}
		
		this.tableInitializeMethod()
		this.$scope.UserInfoConstant = UserInfoConstant;
		this.$scope.$watch('UserInfoConstant[0].details[0]', (details) => {
			if (details !== undefined) {
				this.user = details.user.id;
				this.user_id = details.user.id;
				this.conceptId = details.user.conceptId
				this.init()
			}
		});

	}

	init(){
		this.params = {
			concept_id: this.conceptId
		}
		this.getEducators()
		this.getPeriod()
		this.getLevels()
	}

	tableInitializeMethod() {
		this.detailsEnabled.columnDefs = [
			{field: 'educatorCode', displayName: 'Cod Docente', headerCellClass : 'text-center', },
			{field: 'levelName', displayName: 'Nivel', headerCellClass : 'text-center', },
			{field: 'periodName', displayName: 'Periodo', headerCellClass : 'text-center', },
			{field: 'createdAt', displayName: 'Fecha Habilitación', headerCellClass : 'text-center', },
		]
	}

	getEducators(){
		this.educatorsServices.getEducators(this.params).$promise.then((dataReturn) => {
			if(dataReturn.results.lenght == 0){
				this.ngNotify.set('no existen registros','warn')
			}else{
				this.educators = []
				this.educatorsList = dataReturn.results;
				for (let i in this.educatorsList){
					this.educators.push({
						title: (this.educatorsList[i].ds_last_name !== null && this.educatorsList[i].ds_last_name !== undefined)  ?  this.educatorsList[i].ds_name + ' ' + this.educatorsList[i].ds_last_name : '',
						id_code: this.educatorsList[i].id_code,
						cod: this.educatorsList[i].ds_code,
						coreName: this.educatorsList[i].core ? this.educatorsList[i].core.ds_name : null,
						badges: [
							{
								label: ( (this.educatorsList[i].is_active === true) ? this.$translate('ACTIVE') : this.$translate('INACTIVE')),
								bg: ( (this.educatorsList[i].is_active === true) ? "bg-success" : "bg-dark" ),
								icon: "mdi-check"
							}
						]
					})
				}
			}
		}, (err) => {
			this.ngNotify.set('No se ha podido conectar con el servicio','error');
		})
	}

	getPeriod(){
		this.servicesPeriod.getPeriod().$promise.then((dataReturn) => {
			if(dataReturn.results.lenght == 0){
				this.ngNotify.set('no existen registros','warn')
			}else{
				this.periodList = dataReturn.results
				this.periodList.map((period) => {
					if(period.is_current ){
						this.$scope.periodSelect = period.id_code
					}
				})

				this.params.period_id = this.$scope.periodSelect
			}
		}, (err) => {
			this.ngNotify.set('No se ha podido conectar con el servicio','error');
		})
	}

	getLevels(){
		this.levelsServices.getLevels(this.params).$promise.then((dataReturn) => {
			if(dataReturn.results.lenght == 0){
				this.ngNotify.set('no existen registros','warn')
			}else{
				this.levelsList = dataReturn.results
			}
		}, (err) => {
			this.ngNotify.set('No se ha podido conectar con el servicio','error');
		})
	}

	getEnabledEducator(params){
		this.services.getEnabledEducators(params).$promise.then((dataReturn) => {
			if(dataReturn.results.lenght == 0){
				this.ngNotify.set('no existen registros','warn')
			}else{
				this.detailsEnabled.data = this.setAllDataEnabledEducator(dataReturn.results)
			}
		}, (err) => {
			this.ngNotify.set('No se ha podido conectar con el servicio','error');
		})
	}

	setAllDataEnabledEducator(enabledEducators) {
		return enabledEducators.map(enabled => {
			return {
				enabledId: enabled.id_code,
				educatorCode: (enabled.educator.ds_last_name !== null && enabled.educator.ds_last_name !== undefined)  ?  enabled.educator.ds_name + ' ' + enabled.educator.ds_last_name : '',
				educatorId: enabled.educator.id_code,
				levelName: enabled.level.ds_name,
				levelId: enabled.level.id_code,
				periodName: enabled.period.ano,
				periodId: enabled.period.id_code,
				createdAt: enabled.createdAt			
			}
		})
	}

	selectChanged(periodSelect){
		this.$scope.periodSelect = periodSelect
		this.params.period_id = periodSelect

		if(this.panelConfig){
			this.getEnabledEducator(this.params)
		}
	}

	onClick(item){
		this.getDetailsFunction(item);
		this.panelConfig = true
		this.$scope.buttonActions = true
	}

	getDetailsFunction(params){
		this.educatorName = params.title
		this.educatorId = params.id_code
		this.params.educator_id = params.id_code
		this.params.period_id = this.$scope.periodSelect
		this.getEnabledEducator(this.params)

	}

	edit(){
		this.$scope.editSave = true
		this.$scope.edit = false
		this.$scope.titleList = false
		this.$scope.titleEdit = true
		this.$scope.isDisabled = false
		this.$scope.levelSelect = null
	}

	cancelEdit(){
		this.$scope.editSave = false;
		this.$scope.edit = true;
		this.$scope.titleList = true;
		this.$scope.titleEdit = false;
		this.panelConfig = false
		this.$scope.buttonActions = false
		this.getDetailsFunction({educator_id : this.educatorId});
		
	}

	saveEdit(){
		if(this.$scope.levelSelect === null) {
			this.ngNotify.set('Seleccione un Nivel','warn')
			return
		}

		let params  = {
			period_id   : this.$scope.periodSelect,
			user_id : this.user_id,
			concept_id: this.conceptId,
			level_id: this.$scope.levelSelect,
			educator_id: this.educatorId
		}

		this.services.saveEnabledEducators(params).$promise.then((dataReturn) => {
			if(dataReturn.status == 0){
				this.ngNotify.set('Se habilitó correctamente el Docente','success')
				this.$scope.levelSelect = null
				this.getEnabledEducator(this.params)

			}else{
				if (dataReturn.isUniqueViolation) {
					this.ngNotify.set('Existe habilitación de Docente para periodo seleccionado','warn');
				}
				this.$scope.isDisabled = false;
			}
		}, (err) => {
			if (err.data.isUniqueViolation) {
				this.ngNotify.set('Existe habilitación de Docente para periodo seleccionado','warn');
			} else {
				this.ngNotify.set('No se ha podido conectar con el servicio','error');
			}
			this.$scope.isDisabled = false;
		})

	}

	toggleList(isHide) {
		this.$scope.toggle = isHide
	}
}
enabledEducatorsListController.$inject=['$scope', 'enabledEducatorsServices', 'ngNotify','UserInfoConstant','$state','$filter', 'levelsServices', 'educatorsServices']


// WEBPACK FOOTER //
// ./src/app/admin-panel/enabledEducators/list/enabledEducatorsListController.js